import { User } from "../api/User/User";
import { AppUtils } from '../../utils/index';
export class AdresseModel {
	private ort: string;
	private postleitzahl: string;
	private strasseHausnummer: string;
	private strasse: string;
	private hausnummer: string;
	private postfachnummer: string;
	private ergaenzungszeile: string;
	private auslandsadresse: boolean;
	private landkennzeichen: string;
	private land: string;
	private regionalclubKennung: string;
	private regionalclubCode: string;

	/**
	 * Optional adress addition.
	 */
	get Ergaenzungszeile(): string {
		return this.ergaenzungszeile;
	}

	/**
	 * Optional adress addition.
	 */
	set Ergaenzungszeile(value: string) {
		this.ergaenzungszeile = value;
	}

	get StrasseHausnummer(): string {
		return this.strasseHausnummer;
	}

	set StrasseHausnummer(value: string) {
		this.strasseHausnummer = value;
	}

	get Postfachnummer(): string {
		return this.postfachnummer;
	}

	set Postfachnummer(value: string) {
		this.postfachnummer = value;
	}

	get Postleitzahl(): string {
		return this.postleitzahl;
	}

	set Postleitzahl(value: string) {
		this.postleitzahl = value;
	}

	get Ort(): string {
		return this.ort;
	}

	set Ort(value: string) {
		this.ort = value;
	}

	public get Auslandsadresse(): boolean {
		return this.auslandsadresse;
	}
	public set Auslandsadresse(value: boolean) {
		this.auslandsadresse = value;
	}

	get Landkennzeichen(): string {
		return this.landkennzeichen;
	}

	set Landkennzeichen(value: string) {
		this.landkennzeichen = value;
	}

	get Land(): string {
		return this.land;
	}

	set Land(value: string) {
		this.land = value;
	}

	get RegionalclubKennung(): string {
		return this.regionalclubKennung;
	}

	set RegionalclubKennung(value: string) {
		this.regionalclubKennung = value;
	}

	get RegionalclubCode(): string {
		return this.regionalclubCode;
	}

	set RegionalclubCode(value: string) {
		this.regionalclubCode = value;
	}

	get Strasse(): string {
		return this.strasse;
	}

	set Strasse(value: string) {
		this.strasse = value;
	}

	get Hausnummer(): string {
		return this.hausnummer;
	}

	set Hausnummer(value: string) {
		this.hausnummer = value;
	}

	public toString(): string {
		return JSON.stringify(this);
	}

	/**
	 * Takes over fields from the user object, if not already filled in the model.
	 */
	public mergeWithUser(user: User, advertisingMode = false): void {
		if (user.UserData.Anschrift) {
			if (!this.Ergaenzungszeile || advertisingMode) {
				this.Ergaenzungszeile = user.UserData.Anschrift.Ergaenzungszeile;
			}
			if (!this.StrasseHausnummer || advertisingMode) {
				this.StrasseHausnummer = user.UserData.Anschrift.StrasseHausnummer;
			}
			if (!this.Postfachnummer || advertisingMode) {
				this.Postfachnummer = user.UserData.Anschrift.Postfachnummer;
			}
			if (!this.Postleitzahl || advertisingMode) {
				this.Postleitzahl = user.UserData.Anschrift.Postleitzahl;
			}
			if (!this.Ort || advertisingMode) {
				this.Ort = user.UserData.Anschrift.Ort;
			}
		}
	}

	/**
	 * Creates a new AdresseModel object and copies the values from the provided data object (or other Adresse model) to the created AdresseModel.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): AdresseModel {
		return AppUtils.Helper.createFromMap(dataObject, AdresseModel);
	}
}
